import { Dayjs } from 'dayjs';
import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';

import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers-pro';

type WaveUIDatePickerProps = ComponentPropsWithoutRef<typeof DateTimePicker> & {
  name: string;
  label: ReactNode;
  value?: Dayjs;
  onChange?: (date: Dayjs | null) => void;
  helperText?: string;
  withTime?: boolean;
  error?: boolean;
};

const WaveUIDatePicker: FC<WaveUIDatePickerProps> = ({
  name,
  label,
  value,
  onChange,
  helperText,
  withTime = false,
  error,
}) => {
  return (
    <FormControl error={error} fullWidth>
      <InputLabel htmlFor={`id_${name}`}>{label}</InputLabel>

      {withTime ? (
        <DateTimePicker
          format='YYYY-MM-DD h:mm A'
          name={name}
          label={label}
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              variant: 'outlined',
              error,
            },
          }}
        />
      ) : (
        <DatePicker
          format='YYYY-MM-DD'
          name={name}
          label={label}
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              variant: 'outlined',
              error,
            },
          }}
        />
      )}

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default WaveUIDatePicker;
